import { Certification, CertificationUser, UserCertifications } from 'app/redux/models/Certification.model';
import axiosClient from './utils/axiosClient';

export const CERTIFICATIONS_SET_URI = 'certifications';
export const USERS_URI = '/users';

export function getAllCertificationsApi() {
    return axiosClient.get<Certification[]>(CERTIFICATIONS_SET_URI);
}

export function getCertificationsByUserIdApi(userId: number) {
    return axiosClient.get<Certification[]>(`${CERTIFICATIONS_SET_URI + USERS_URI}/${userId}`);
}

export function getAllUserCertificationsApi() {
    return axiosClient.get<UserCertifications[]>(CERTIFICATIONS_SET_URI + USERS_URI);
}

export function addCertificationToUserApi(certificationUser: CertificationUser) {
    return axiosClient.post<CertificationUser>(CERTIFICATIONS_SET_URI + USERS_URI, certificationUser);
}
